import { ChipFilterable as UIChipFilterable } from "@webmotors/eleanor-ui";

export interface ChipFilterableProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  label: string;
  onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
  size?: "small" | "medium";
  state?: "disabled" | "active" | "default";
  quantityText?: string;
  leftIcon?: React.ReactNode;
  /**
   * @deprecated variant não está mais sendo utilizado para estilização.
  */
  variant?: 'outline' | 'filled' | 'situational';
}

export function ChipFilterable({
  className,
  label,
  onClick,
  size = "medium",
  state = "default",
  quantityText,
  leftIcon,
  ...props
}: Readonly<ChipFilterableProps>) {
  return (
    <UIChipFilterable
      className={className}
      label={label}
      onClick={onClick}
      size={size}
      state={state}
      quantityText={quantityText}
      leftIcon={leftIcon}
      {...props}
    >
    </UIChipFilterable>
  );
}